import { updateModel } from '../../data/Model'
import { requestAPI } from '../../data/api'

export default function getUsers() {
	updateModel(model => {
		model.users.status.handle = 'loading'
		return model
	})

	return requestAPI('/authentication/users', 'GET').then(users => {
		console.log(users.length)
		updateModel(model => {
			if (users.length > 0) {
				model.users.data = users
				model.users.data.map(el => {
					el.clients = el.hubs // TODO remove this fix
				})
				model.users.data.clients = model.users.data.hubs // TODO remove this dirty fix as well
			}
			model.users.status.handle = 'loaded'
			model.users.status.timestamp = new Date()
			return model
		})
	})
}
